import { render, staticRenderFns } from "./AskIntro.vue?vue&type=template&id=0caed9e8&scoped=true&"
import script from "./AskIntro.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskIntro.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskIntro.vue?vue&type=style&index=0&id=0caed9e8&prod&scoped=true&lang=css&"
import style1 from "./AskIntro.vue?vue&type=style&index=1&id=0caed9e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caed9e8",
  null
  
)

export default component.exports